import React, { useState, useContext, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import apiClient from "../api/apiClient";
import "../css/LoginWithMpin.css";
// import logo from "../assets/icons/logo.png";
import logo from "../assets/icons/dpboss.png";
import "../css/mainhome.css";
import { AppContext } from "../context/AppContext";
import { toast } from "react-toastify";

export default function LoginWithMPin() {
  const { mobileNo, setMobileNo, setUser } = useContext(AppContext);
  const [password, setPasswordLocal] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const storedAccessToken = localStorage.getItem("accessToken");
  const storedRegisterId = localStorage.getItem("registerId");
  const isMpinUnlock = Boolean(storedAccessToken && storedRegisterId);
  const loginMobileNo =
    mobileNo ||
    localStorage.getItem("mobileNo") ||
    localStorage.getItem("lastLoginMobileNo") ||
    "";

  useEffect(() => {
    if (loginMobileNo && !mobileNo && setMobileNo) {
      setMobileNo(loginMobileNo);
      return;
    }

    if (!loginMobileNo && !isMpinUnlock) {
      navigate("/enter-mobile", { replace: true });
    }
  }, [isMpinUnlock, loginMobileNo, mobileNo, navigate, setMobileNo]);

  const loadProfile = async (registerId) => {
    const profileRes = await apiClient.post(
      "/user-details-by-register-id",
      { registerId }
    );

    if (profileRes.data.status === true && profileRes.data.info) {
      const userInfo = profileRes.data.info;
      localStorage.setItem("userProfile", JSON.stringify(userInfo));
      localStorage.setItem("walletBalance", userInfo.walletBalance);

      const profileMobileNo = userInfo.mobileNo || loginMobileNo;
      if (profileMobileNo) {
        localStorage.setItem("mobileNo", profileMobileNo);
        localStorage.setItem("lastLoginMobileNo", profileMobileNo);
        if (setMobileNo) setMobileNo(profileMobileNo);
      }

      if (setUser) setUser(userInfo);
      return true;
    }

    return false;
  };

  const handleLogin = async () => {
    if (!password.trim()) {
      toast.warn(isMpinUnlock ? "Please enter your MPIN" : "Please enter your password or MPIN");
      return;
    }

    if (isMpinUnlock && !/^\d{4}$/.test(password)) {
      toast.warn("Please enter a valid 4-digit MPIN");
      return;
    }

    setIsLoading(true);

    try {
      if (isMpinUnlock) {
        const verifyRes = await apiClient.post("/verify-mpin", {
          registerId: storedRegisterId,
          pinNo: password,
        });

        if (verifyRes.data.status === true) {
          const profileLoaded = await loadProfile(storedRegisterId);
          if (!profileLoaded) {
            toast.warn("MPIN verified, but failed to load profile.");
          } else {
            toast.success("MPIN verified!");
          }

          navigate("/home", { replace: true });
        } else {
          toast.error(verifyRes.data.msg || "Incorrect MPIN. Please try again.");
        }

        return;
      }

      const res = await apiClient.post("/user-login", {
        mobileNo: loginMobileNo,
        password,
        fcmToken: "",
      });

      if (res.data.status === true) {
        const { registerId, accessToken } = res.data.info;

        // clear old tokens
        localStorage.removeItem("accessToken");
        localStorage.removeItem("registerId");

        // save new token
        localStorage.setItem("registerId", registerId);
        localStorage.setItem("accessToken", accessToken);

        localStorage.setItem("mobileNo", loginMobileNo);
        localStorage.setItem("lastLoginMobileNo", loginMobileNo);

        if (await loadProfile(registerId)) {
          toast.success("Login successful!");
          navigate("/home", { replace: true });
        } else {
          toast.warn("Login successful, but failed to load profile.");
          navigate("/home", { replace: true });
        }
      } else {
        toast.error(res.data.msg || "Invalid password. Please try again.");
      }
    } catch (err) {
      console.error("Login process failed:", err?.response || err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="mainhome-screen-wrapper">
      <div className="top-header">{isMpinUnlock ? "Enter MPIN" : "Login"}</div>

      <div
        className="mpin-container"
        style={{ justifyContent: "flex-start", paddingTop: "60px" }}
      >
        <img
          src={logo}
          alt="Logo"
          className="mpin-logo"
          style={{ height: "120px", marginBottom: "40px" }}
        />

        <div
          className="mpin-card"
          style={{
            boxShadow: "0 8px 32px rgba(0,0,0,0.08)",
            border: "1px solid #f0f0f0",
          }}
        >
          <h2
            style={{
              fontSize: "22px",
              color: "#121212",
              marginBottom: "30px",
            }}
          >
            {isMpinUnlock ? "Welcome Back" : "Login"}
          </h2>

          <div
            className="input-group"
            style={{ width: "100%", marginBottom: "20px" }}
          >
            <input
              type="password"
              inputMode={isMpinUnlock ? "numeric" : "text"}
              maxLength={isMpinUnlock ? 4 : undefined}
              placeholder={isMpinUnlock ? "Enter MPIN" : "Enter Password / MPIN"}
              className="mpin-input"
              style={{ textAlign: "center", fontSize: isMpinUnlock ? "24px" : "18px", letterSpacing: "0" }}
              value={password}
              onChange={(e) => {
                const nextValue = isMpinUnlock
                  ? e.target.value.replace(/\D/g, "").slice(0, 4)
                  : e.target.value;
                setPasswordLocal(nextValue);
              }}
              autoFocus
            />
          </div>

          <button
            className="mpin-login-btn"
            onClick={handleLogin}
            disabled={isLoading}
          >
            {isLoading ? (isMpinUnlock ? "VERIFYING..." : "LOGGING IN...") : (isMpinUnlock ? "VERIFY MPIN" : "LOGIN")}
          </button>

          {!isMpinUnlock && <div style={{ marginTop: "20px" }}>
            <a
              href="/forgot-password"
              style={{
                color: " #fdb063",
                fontSize: "14px",
                fontWeight: "500",
              }}
            >
              Forgot Password?
            </a>
          </div>}
        </div>
      </div>
    </div>
  );
}
